import { isSameId } from "../../helpers";
import { uid } from "@xbs/lib-state";
export default function (store, { target, dropPosition, mode }) {
    if (store.existsTask(target)) {
        const targetTask = store.getTask(target);
        const action = mode === "move" ? "move-task" : "copy-task";
        if ((!targetTask.draggable && mode === "move") || mode === "copy") {
            const reversed = dropPosition === "bottom";
            const selected = store.getSelection({ sorted: true });
            const batch = selected.filter(t1 => {
                const task1 = store.getTask(t1);
                return !selected.some(t2 => {
                    return isSameId(store.getTask(t2).id, task1.parent);
                });
            });
            let $meta;
            if (selected.length > 1) {
                $meta = { batch: uid() };
            }
            store.eachSelected((id, index) => {
                const parent = store.getTask(store.getTask(id).parent);
                !parent?.selected &&
                    store.in.exec(action, {
                        id,
                        parent: dropPosition === "in"
                            ? target
                            : targetTask.parent,
                        targetId: target,
                        reverse: dropPosition === "top",
                        skipProvider: !!index,
                        batch: !index && batch.length > 1 ? batch : null,
                        $meta,
                    });
            }, true, reversed);
        }
    }
    const { draggableIds } = store.getState();
    for (let index = 0; index < draggableIds.length; index++) {
        store.updateTask({
            id: draggableIds[index],
            task: {
                draggable: false,
            },
            skipStateCalc: index !== draggableIds.length - 1,
        });
    }
    store.setState({ draggableIds: [], dragInfo: null });
}
//# sourceMappingURL=end.js.map